import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import m3cRatings from "../../../../src/data/articles/cube-prospective-modern-horizons-3-commander/m3c-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  m3cRatings,
  ProspectiveIntro,
  React
};